import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'
import logoLong from '../../images/logo-long.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'

const PORTAL_URL = 'https://www.optimantra.com/optimus/om/patient/login'
const BOOK_URL =
  'https://www.optimantra.com/optimus/patient/patientaccess/servicesall?mid=1023&pid=NWxtalFOa1M1ZDZwSTNwZ3AzY08vdz09&lid=TmNIZ3FKUFdhVm1YME1lQkMxUEE5QT09&hideFooterInFrame=&hideHeaderInFrame='

const Footer = () => {
  const year = new Date().getFullYear()

  return (
    <footer className="site-footer">
      <div className="footer__accent" aria-hidden="true" />
      <div className="footer__shell">
        <div className="footer__main">
          <div className="footer__col footer__col--brand">
            <Link to="/" className="footer__logo-link" aria-label="The Functional Nurse Practitioner — Home">
              <img
                src={logoLong}
                alt=""
                className="footer__logo"
                width={1048}
                height={238}
                loading="lazy"
                decoding="async"
              />
            </Link>
            <p className="footer__tagline">Clinical wellness reinvented — root-cause care for lasting vitality.</p>
          </div>

          <div className="footer__col">
            <h2 className="footer__heading">Explore</h2>
            <ul className="footer__links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/what-is-functional-medicine">Our approach</Link>
              </li>
              <li>
                <Link to="/membership">Membership</Link>
              </li>
              <li>
                <Link to="/podcast">Podcast</Link>
              </li>
            </ul>
          </div>

          <div className="footer__col">
            <h2 className="footer__heading">Patient resources</h2>
            <ul className="footer__links">
              <li>
                <a href={PORTAL_URL} target="_blank" rel="noopener noreferrer">
                  Secure client portal
                </a>
              </li>
              <li>
                <a href={BOOK_URL} target="_blank" rel="noopener noreferrer">
                  Book a free consultation
                </a>
              </li>
            </ul>
          </div>

          <div className="footer__col">
            <h2 className="footer__heading">Contact</h2>
            <ul className="footer__contact">
              <li>
                <span className="footer__contact-icon" aria-hidden="true">
                  <FontAwesomeIcon icon={faPhone} />
                </span>
                <a href="tel:9303331435">930-333-1435</a>
              </li>
              <li>
                <span className="footer__contact-icon" aria-hidden="true">
                  <FontAwesomeIcon icon={faEnvelope} />
                </span>
                <a href="mailto:info@thefunctionalnursepractitioner.com">info@thefunctionalnursepractitioner.com</a>
              </li>
              <li>
                <span className="footer__contact-icon" aria-hidden="true">
                  <FontAwesomeIcon icon={faLocationDot} />
                </span>
                <span className="footer__address">
                  8063 Madison Ave #1180
                  <br />
                  Indianapolis, Indiana 46227
                  <br />
                  United States
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__divider" aria-hidden="true" />

        <div className="footer__bottom">
          <p className="footer__copy">
            © {year} The Functional Nurse Practitioner. All rights reserved.
          </p>
          <nav className="footer__socials" aria-label="Social media">
            <a
              href="https://www.facebook.com/thefunctionalnursepractitioner"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook — The Functional Nurse Practitioner"
            >
              <FontAwesomeIcon icon={faFacebook} aria-hidden="true" />
            </a>
            <a
              href="https://www.instagram.com/thefunctionalnursepractitioner/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram — The Functional Nurse Practitioner"
            >
              <FontAwesomeIcon icon={faInstagram} aria-hidden="true" />
            </a>
            <a
              href="https://www.youtube.com/channel/UCYoSkehh4-qfo1asa-DEKDg"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube — The Functional Nurse Practitioner"
            >
              <FontAwesomeIcon icon={faYoutube} aria-hidden="true" />
            </a>
          </nav>
        </div>
      </div>
    </footer>
  )
}

export default Footer
